import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=85de0eea&scoped=true"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"
import style0 from "./layout.vue?vue&type=style&index=0&id=85de0eea&lang=less&scoped=true"
import style1 from "./layout.vue?vue&type=style&index=1&id=85de0eea&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85de0eea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Workplace\\vueProject\\edu_aim\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85de0eea')) {
      api.createRecord('85de0eea', component.options)
    } else {
      api.reload('85de0eea', component.options)
    }
    module.hot.accept("./layout.vue?vue&type=template&id=85de0eea&scoped=true", function () {
      api.rerender('85de0eea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/admin/layout.vue"
export default component.exports